module.exports = __webpack_public_path__ + "static/media/NFBKC.f614347c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/shgn/footerLogos/mobile/NFBKC.svg
// module id = 105
// module chunks = 0